<template>
  <div class="print">

    <section>
      <div>
        <p class="print-title mb-10">{{ form.inspectTitle }}</p>
        <div class="division-title">□ 기본정보</div>
      </div>

      <table>
        <colgroup>
          <col width="140" />
          <col width="230" />
          <col width="140" />
          <col width="230" />
          <col width="140" />
          <col width="230" />
        </colgroup>
        <tr>
          <th>사업장명</th>
          <td>{{ form.stdInfo.field_name }}</td>
          <th>소재지</th>
          <td colspan="3">{{ form.stdInfo.field_address }}</td>
        </tr>
        <tr>
          <th>소속명</th>
          <td>{{ form.stdInfo.department }}</td>
          <th>작성자</th>
          <td>{{ form.stdInfo.writer_name }}</td>
          <th>작성일</th>
          <td>{{ form.stdInfo.date }}</td>
        </tr>
        <tr>
          <th>점검일</th>
          <td>{{ form.subInfo.점검일 }}</td>
          <th>소속명</th>
          <td>{{ form.subInfo.소속명 }}</td>
          <th>점검자</th>
          <td>{{ form.subInfo.점검자 }}</td>
        </tr>
      </table>
    </section>

    <section>
      <div class="mt-28px">
        <div class="division-title">□ {{ form.inspectTitle }}</div>
      </div>

      <table-inspect-merge
        :is-print="true"
        :is-readonly="board.readonly"
        table-header-title="점검항목"
        table-header-check-title="평가"
        :table-header-check="[{ text: '적정' }, { text: '보통' }, { text: '미흡'}, {text: '해당없음'}]"
        :tableHeaderNote="[{ text: '비고', mobileText: '비고', width:  200},]"
        content-before="numbering"
        v-model="form.inspectList"
        :only-pc="true"
        class="table-inspect-merge-print"
      />
    </section>
  </div>
</template>

<script>
import PrintCheckbox from "@/components/print/PrintCheckbox.vue";
import TableInspectMerge from "@/components/TableInspectMerge.vue";

export default {
  name: "Print",
  components: {TableInspectMerge, PrintCheckbox},

  props: {
    isPrint: Boolean,
    board: Object,
    form: Object,
  },
}
</script>

<style lang="scss" scoped>
.print {
  .print-title {
    font-size: 32px;
    font-weight: bold;
    color: #000;
    text-align: center;
    padding: 20px 0;
  }
  .division-title {
    font-size: 24px;
    font-weight: bold;
    color: #3C3C3C;
    padding: 1.25rem 0rem;
  }

  /* 테이블 공통 (색상, 테두리 등) */
  table {
    width: 100%;
    table-layout: fixed;
    border-collapse: collapse;

    th, td {
      border: 1px solid #757575;
      text-align: center;
      font-size: 18px;
    }
    th {
      background-color: #ececec;
      font-weight: 500;
      padding: 1.5rem 0;
    }
    td {
      word-break: keep-all;
      img {
        display: inline-block;
      }
    }
    .th-background {
      background-color: #ececec;
      white-space: nowrap;
    }
    .check-container {
      padding: 10px 14px 0 14px;
      text-align: left;

      div {
        margin-bottom: 8px;
      }
      img {
        display: inline-block;
        margin-right: 8px;
      }
    }
    .text-left {
      text-align: left;
      padding: 10px 14px;
    }
  }

  /* 결재란 */
  .section-approval {
    display: grid;
    grid-template-columns: 1fr auto;

    .table-approval-field {
      th { width: 120px; padding: 10px 14px;}
      th:first-child { width: 38px }
      td { height: 80px; }

      tr:last-child {
        th, td { border-bottom: none }
      }
    }
  }

  /* 기본정보 */
  .section-stdInfo {
    th { width: 140px; }
    td div { border: none; }
  }

  /* 점검대상 */
  .section-inspect {
    td {
      padding: 1rem;
      text-align: left
    }
  }

  .section-file {
    th { width: 234px; }
  }

  .section-photo {
    td { padding: 1rem; }
  }
}
.table-inspect-merge-print {
  h5 {
    font-size: 24px;
    font-weight: 700;
    line-height: 35px;
    color: #3c3c3c;

    display: flex;
    align-items: center;

    .dot {
      width: 20px;
      height: 20px;
      background-color: transparent;
      border: 1px solid #3c3c3c;
      border-radius: 0;
      display: inline-block;
      margin-top: 3px;
      margin-right: 14px;
    }
  }

  .print-textarea,
  .print-input {
    border: none;
    border-radius: 0;
  }

  table {
    th,
    td {
      border: 1px solid #757575 !important;
      min-height: 55px !important;
      height: 55px !important;
      font-size: 18px !important;
      text-align: center !important;
    }
    th {
      background-color: #ececec !important;
      font-weight: 500 !important;
      padding: 0 !important;
    }

    .title-tr > td {
      background-color: #ececec !important;
      text-align: left !important;
    }

    .content[colspan='4'],
    .content[colspan='7']{
      padding: 0 !important;

      & > div {
        display: grid !important;
        grid-template-columns: auto 1fr;
        gap: 0 !important;
      }
      p {
        flex: none ;
        padding: 0.7rem !important;
        width: 140px !important;
        height: 100% !important;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      span {
        margin: 0 !important;
        border-left: 1px solid #757575 !important;
        white-space: pre-wrap;

        display: grid;
        align-items: center;
      }
    }
  }
}


@media print {
  .page-break { page-break-inside:avoid; page-break-after:auto }
  thead { display:table-header-group; }
}
</style>
